import { IGameDevelopersContext, IFilterValues } from './gameDevelopersContext';

export enum GameDevelopersActionTypes {
	SET_GAME_DEVELOPERS = 'SET_GAME_DEVELOPERS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_EDIT = 'SET_ID_FOR_EDIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
	REFETCH_DEVELOPERS = 'REFETCH_DEVELOPERS',
}

interface ISetGameDevelopers {
	type: GameDevelopersActionTypes.SET_GAME_DEVELOPERS;
	payload: {
		gameDevelopers: IGameDevelopersContext['gameDevelopers'];
		typeOfModalWindow: IGameDevelopersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: GameDevelopersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IGameDevelopersContext['searchString'];
	};
}

interface IResetSelectedControls {
	type: GameDevelopersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: GameDevelopersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IGameDevelopersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: GameDevelopersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IGameDevelopersContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: GameDevelopersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IGameDevelopersContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: GameDevelopersActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IGameDevelopersContext['IDForDeletion'];
		typeOfModalWindow: IGameDevelopersContext['typeOfModalWindow'];
	};
}

interface ISetIDForEdit {
	type: GameDevelopersActionTypes.SET_ID_FOR_EDIT;
	payload: {
		IDForEdit: IGameDevelopersContext['IDForEdit'];
		typeOfModalWindow: IGameDevelopersContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: GameDevelopersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IGameDevelopersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: GameDevelopersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

interface IRefetchDevelopers {
	type: GameDevelopersActionTypes.REFETCH_DEVELOPERS;
	payload: {
		needRefetchDevelopers: IGameDevelopersContext['needRefetchDevelopers'];
	};
}

export type TGameDevelopersAction =
	| ISetGameDevelopers
	| IChangeSearchString
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForEdit
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString
	| IRefetchDevelopers;
